import { Collapse, Descriptions, theme, CollapseProps } from "antd";
import RateioFluxoRelatorio from "../../../../../../../Models/Financeiro/Titulo/Rateio/RateioFluxoRelatorio";
import Utilitario from "../../../../../../../Utils/Utilitario";
import { CaretRightOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
export interface IRateioFluxoRelatorioCollapseProps extends CollapseProps {
    rateioFluxoRelatorioParam?:RateioFluxoRelatorio;
    codigoContabilPai?:string;
    loading?:boolean;
    dataSource?:RateioFluxoRelatorio[];
}
function DescriptionsRateioRelatorio({ relatorioItem, codigoContabilPai }:{relatorioItem:RateioFluxoRelatorio; codigoContabilPai?:string;}) {
    return <Descriptions 
        size="small"
        bordered={false}
        column={6}
        layout="vertical"
        items={[
            {
                key: '1',
                label: 'Plano de conta',
                children: `${codigoContabilPai ?? ""}${relatorioItem.planoContas!.codigoContabil} - ${relatorioItem.planoContas!.descricao}`,
                span : 1,
            },
            {
                key: '2',
                label: 'Vl. Previsto',
                children: Utilitario.toStringDinheiro(relatorioItem.valorPrevisto),
                span : 1,
            },
            {
                key: '3',
                label: 'Vl. Recebido',
                children: Utilitario.toStringDinheiro(relatorioItem.valorRecebido),
                span : 1,
            }
        ]} 
    />
}
export default function RateioFluxoRelatorioCollapseBasic({
    loading,
    dataSource,
    codigoContabilPai,
    ...props
}:IRateioFluxoRelatorioCollapseProps) {
    const { token } = theme.useToken();
    const [ keys, setKeys ] = useState([] as string[]);
    
    const itens = useMemo(() => {
        return dataSource?.map(m => {
            return {
                key : (m.filhos?.length ?? 0) > 0 ? m.planoContas!.codigo : -1,
                headerClass : "alignItemsCenter",
                label : <DescriptionsRateioRelatorio relatorioItem={m} codigoContabilPai={codigoContabilPai} />,
                children : (m.filhos?.length ?? 0) === 0 ? undefined : <RateioFluxoRelatorioCollapseBasic {...props} codigoContabilPai={`${codigoContabilPai ?? ""}${m.planoContas!.codigoContabil}`} dataSource={m.filhos} loading={loading} />,
                showArrow : (m.filhos?.length ?? 0) > 0,
            }
        }) as CollapseProps["items"];
    }, [dataSource]);

    useEffect(() => setKeys(dataSource?.map(m => m.planoContas!.codigo?.toString() ?? "") ?? []), [dataSource]);

    return <Collapse 
        size="small"
        bordered={true}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
        style={{ background: token.colorBgContainer }}
        activeKey={keys}
        onChange={(keys) => setKeys((typeof keys === "string" ? [keys] : keys).filter(f => f !== "-1"))}
        items={itens}
    />;
}